import axios from "../axios";

class ForwarderService {

  static Instance() {
    return new ForwarderService();
  }

  getAllForwarder(request) {
    return axios.post("/api/forwarder/list/all", request);
  }

  getForwarderDropDown(forwarderName) {
    return axios.get("/api/forwarder/dropdown?forwarderName=" + forwarderName);
  }

  createForwarder(request) {
    return axios.post("/api/forwarder/", request)
  }

  getForwarderDetails(id) {
    return axios.get("/api/forwarder/details?forwarderId=" + id);
  }

  updateForwarder(request) {
    return axios.post("/api/forwarder/update", request);
  }

  deleteForwarder(forwarderId) {
    return axios.post("/api/forwarder/delete?forwarderId=" + forwarderId);
  }
}

export default ForwarderService.Instance();